var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('index-header'),_c('el-container',[_c(_vm.asideComponent,{tag:"component"}),_c('index-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }